<!--配色管理-配色关系-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm"></ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:colorRelation:add']" @click="onCreateMaterial">新增</a-button>
        <a-button :loading="loading" v-hasPermi="['mdm:colorRelation:delete']" @click="onDelete">删除</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:colorRelation:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:colorRelation:export']" @click="handleExport">导出</a-button>
        <create-material-modal ref="createMaterialModalRef" @refresh="handleOk" />
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <download-modal :apiFun="apiMaterialMatchColorConfigExport" ref="download" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true }">
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import createMaterialModal from '@/views/color-management/color-relation/components/create-material-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'
import {
  apiMaterialMatchColorConfigDel,
  apiMaterialMatchColorConfigExport,
  apiMaterialMatchColorConfigList
} from '@/api/color-management/color-relation/colorRelationApi'
import ImportExcel from "@/components/ImportExcel/importExcel"
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'

export default {
  name: 'ColorRelation',
  components: { createMaterialModal, ImportExcel, DownloadModal },
  mixins: [cacheSearch],
  data() {
    return {
      apiMaterialMatchColorConfigExport,
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMaterialMatchColorConfigList, false),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/materialMatchColorConfig/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'mdm/materialMatchColorConfig/template',
        name: `配色关系导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 查询参数
      queryParams: {
        primaryItemCode: undefined,
        secondaryItemCode: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined
      },
      formList: [
        { label: '材料编码1(主)', decorator: ['primaryItemCode'], type: 'input' },
        { label: '材料编码2(辅)', decorator: ['secondaryItemCode'], type: 'input' },
        {
          label: '创建日期',
          type: 'range',
          decorator: ['createTime'],
          disposeFormat: {
            createTimeStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            createTimeEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '材料编码1(主)', dataIndex: 'primaryItemCode', align: 'center', width: 130 },
        { title: '材料名称1(主)', dataIndex: 'primaryItemName', align: 'center' },
        { title: '材料编码2(辅)', dataIndex: 'secondaryItemCode', align: 'center', width: 130 },
        { title: '材料名称2(辅)', dataIndex: 'secondaryItemName', align: 'center' },
        { title: '创建日期', dataIndex: 'createTime', align: 'center', width: 150 }
      ]
    }
  },
  created() {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache('refSearchForm', '', { createTime: ['createTimeStart', 'createTimeEnd'] })
      this.$nextTick(() => { this.onSearch() })
    } else {
      this.$nextTick(() => {
        const tempSearchForm = this.$refs.refSearchForm
        tempSearchForm.form.setFieldsValue({
          createTime: [ moment().subtract(30, 'days'), moment() ]
        })
        this.onSearch(
          {
            createTimeStart: moment().subtract(30, 'days').format('YYYY-MM-DD 23:59:59'),
            createTimeEnd: moment().format('YYYY-MM-DD 00:00:00')
          }
        )
      })
    }
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 新增物料
    onCreateMaterial() {
      this.$refs.createMaterialModalRef.show()
    },
    // 删除
    onDelete() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否删除勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const ids = self.selectedRows.map(item => item.id).join(',')
          apiMaterialMatchColorConfigDel(ids).then(res => {
            if (res?.code === 200) {
              self.$message.success(res?.msg || '操作成功')
              self.handleOk()
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        primaryItemCode: undefined,
        secondaryItemCode: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less"></style>
